module.exports = {
  FEEDBACK_REQUEST: "FEEDBACK_REQUEST",
  FEEDBACK_LIST_SUCCESS: "FEEDBACK_LIST_SUCCESS",
  FEEDBACK_LIST_FAIL: "FEEDBACK_LIST_FAIL",
};
